// Mock data for portfolio
import { projects } from './projectsData';

export { projects };

export const profileData = {
  name: "Zainul Muhajir",
  title: "Android Developer & Machine Learning Engineer",
  bio: "Android Developer with over three years of experience in software engineering. During my studies at Telkom University, I actively improved my technical skills through intensive programmes lasting five months at Infinite Learning and six months at Bangkit Academy 2024 Batch 1. Over the past two years, I have been actively involved in various freelance projects, which have broadened my horizons, particularly in the field of Machine Learning. I am also highly interested in developing AI Agents to create intelligent and autonomous solutions.",
  email: "zainulmuhajir5@gmail.com",
  location: "Pemalang, Indonesia",
  profileImage: "https://customer-assets.emergentagent.com/job_muhajir-dev/artifacts/pn5bdwi7_1000143112.jpg",
  socialLinks: [
    {
      id: 1,
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/zainul-muhajir-30a271224/",
      icon: "linkedin"
    },
    {
      id: 2,
      name: "GitHub",
      url: "https://github.com/zai-code-star",
      icon: "github"
    },
    {
      id: 3,
      name: "GitHub 2",
      url: "https://github.com/Zainul-Code",
      icon: "github"
    },
    {
      id: 4,
      name: "Instagram",
      url: "https://www.instagram.com/zaaiii___",
      icon: "instagram"
    },
    {
      id: 5,
      name: "Informatika",
      url: "https://www.instagram.com/jokiinformatika2026",
      icon: "instagram"
    },
    {
      id: 6,
      name: "PDDIKTI",
      url: "https://pddikti.kemdiktisaintek.go.id/detail-mahasiswa/Hs_WZG9bbRrIHm1EIy-scvAatPfohkGgygPx2EP9pH1k0eHobsKnUaiw-ZvGTmYMufHC5g==",
      icon: "graduation-cap"
    },
    {
      id: 7,
      name: "Dev.to",
      url: "https://dev.to/zainul_muhajir",
      icon: "code"
    },
    {
      id: 8,
      name: "Research",
      url: "https://repository.telkomuniversity.ac.id/pustaka/244762/klasifikasi-komentar-teks-promosi-judi-online-pada-media-sosial-tiktok-menggunakan-machine-learning-dalam-bentuk-buku-karya-ilmiah.html",
      icon: "book-open"
    }
  ]
};

export const skills = [
  { name: "Kotlin", category: "mobile" },
  { name: "Java", category: "mobile" },
  { name: "Flutter", category: "mobile" },
  { name: "Dart", category: "mobile" },
  { name: "Scikit-Learn", category: "ml" },
  { name: "NumPy", category: "ml" },
  { name: "Pandas", category: "ml" },
  { name: "Python", category: "ml" },
  { name: "TensorFlow", category: "ml" },
  { name: "Firebase", category: "backend" },
  { name: "MySQL", category: "backend" },
  { name: "Git", category: "tools" },
  { name: "Android Studio", category: "tools" },
  { name: "Jupyter Notebook", category: "tools" },
  { name: "PyCharm", category: "tools" }
];

export const experience = [
  {
    id: 1,
    title: "Freelance Developer",
    company: "Jasa/Layanan",
    period: "Mei 2024 - Saat ini · 1 thn 10 bln",
    location: "Indonesia · Di lokasi",
    description: "Providing technical consulting services, custom software development, and scientific/technical writing. Focusing on problem solving and code implementation according to client specifications.",
  },
  {
    id: 2,
    title: "Mobile Application Developer",
    company: "Bangkit led by Google, Goto, and Traveloka",
    period: "Feb 2024 - Jul 2024 · 6 bln",
    location: "Jakarta Raya, Indonesia · Jarak jauh",
    description: "Program Bangkit is a collaborative initiative led by Google, Tokopedia, Gojek, and Traveloka. The program aims to train and develop tech talent in Indonesia. During this program, participants undergo intensive 6-month training with a focus on machine learning and cloud computing. Participants learn from industry experts and leading practitioners, and have the opportunity to work on real projects. The Bangkit program aims to create graduates who are ready to contribute to the tech industry and strengthen the digital ecosystem in Indonesia.",
  },
  {
    id: 3,
    title: "Mobile Application Developer",
    company: "Infinite Learning Indonesia · MSIB",
    period: "Des 2022 - Jan 2023 · 2 bln",
    location: "Batam, Kepulauan Riau, Indonesia · Jarak jauh",
    description: "Develop Buildrrr App in Android Studio, slicing the UI design. I also implemented Firebase as the backend service to handle real-time data synchronization, user authentication, and database management, ensuring a seamless connection between the front-end and back-end.",
  },
  {
    id: 4,
    title: "Mobile Application Developer",
    company: "Infinite Learning Indonesia · MSIB",
    period: "Nov 2022 - Nov 2022 · 1 bln",
    location: "Batam, Kepulauan Riau, Indonesia · Jarak jauh",
    description: "Implemented the Medich App design into Android Studio using Java and XML. My role was to transform high-fidelity mockups from the design team into a functional Android front-end, ensuring pixel-perfect layouts, responsive UI components, and smooth navigation throughout the application.",
  },
  {
    id: 5,
    title: "UI UX Applications",
    company: "Infinite Learning Indonesia · MSIB",
    period: "Sep 2022 - Okt 2022 · 2 bln",
    location: "Batam, Kepulauan Riau, Indonesia · Jarak jauh",
    description: "Make design UI/UX for BHealth, a digital education platform focused on child development. Crafted an intuitive interface and a seamless user experience to help parents easily monitor milestones and access reliable health education for their children.",
  }
];

export const education = [
  {
    id: 1,
    degree: "Bachelor of Computer Science at Software Engineering Department",
    institution: "Telkom University",
    period: "2020 - 2025",
  }
];

export const certificates = [
  {
    id: 1,
    title: "Junior Mobile Programmer",
    issuer: " Badan Nasional Sertifikasi Profesi BNSP",
    link: "https://drive.google.com/file/d/1ZSEbemsg2MAqIhp9_nMglUxB8uyKpIUU/view?usp=drivesdk"
  },
  {
    id: 2,
    title: "Top 3 Mobile Project",
    issuer: "Infinite Learning Indonesia",
    link: "https://drive.google.com/file/d/1p4YQJQ9nUdRbAjxoV-ivfnHRmTl45R5U/view?usp=drivesdk"
  },
  {
    id: 3,
    title: "MSIB Participant",
    issuer: "Infinite Learning Indonesia",
    link: "https://drive.google.com/file/d/1JB0ymEmk78K8Gq6CWeSP2Lp9exnqqbbK/view?usp=drivesdk"
  },
  {
    id: 4,
    title: "Memulai Pemrograman dengan Kotlin",
    issuer: "Dicoding Indonesia",
    link: "https://www.dicoding.com/certificates/98XW2JNK9PM3"
  },
  {
    id: 5,
    title: "Belajar Membuat Aplikasi Android untuk Pemula",
    issuer: "Dicoding Indonesia",
    link: "https://www.dicoding.com/certificates/GRX5QRDE3Z0M"
  },
  {
    id: 6,
    title: "Belajar Dasar Git dengan GitHub",
    issuer: "Dicoding Indonesia",
    link: "https://www.dicoding.com/certificates/JMZVDW9JRZN9"
  },
  {
    id: 7,
    title: "Belajar Prinsip Pemrograman SOLID",
    issuer: "Dicoding Indonesia",
    link: "https://www.dicoding.com/certificates/MRZM60YNKPYQ"
  },
  {
    id: 8,
    title: "Memulai Dasar Pemrograman untuk Menjadi Pengembang Software",
    issuer: "Dicoding Indonesia",
    link: "https://www.dicoding.com/certificates/0LZ020R2QX65"
  },
  {
    id: 9,
    title: "Android Development",
    issuer: "Udemy",
    link: "https://ude.my/UC-ad25894d-9cc4-442f-8942-7b7c6da1f6fb"
  }
];
